<template>
	<eg-modal :height="'300px'" :width="'800px'" :show="show" @close="close()">
		<p class="center" slot="header"><b style="color: green">Sucesso</b></p>
		<div slot="body" class="row">
			<div class="col xl12 l12 m12 s12">
				<p>
					Sua solicitação foi recebida, aguarde o contato de nossos
					consultores.
				</p>
			</div>
		</div>
		<!-- <div slot="footer" class="modal-footer">
			<a @click="close()" class="btn">Ok</a>
		</div> -->
	</eg-modal>
</template>

<script>
export default {
    name: 'SubscriptionNotification',
    props: {
        show: Boolean,
    },
    methods: {
        close() {
            this.$emit('close', false);
        },
    },
};
</script>

<style></style>
